// import React, { useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import "./BanScrollParatha.css";
// const SLIDES = [
//   {
//     image: "/img/banscroll1.webp",
//     // image: "/images/scroll1.jpg",
//     alt: "Three women in handwoven sarees",
//     eyebrow: "Empowering Indian Weavers",
//     title: "Luxury You Can Trust",
//     text: "Celebrate Indian artisanship with sarees selected for superior drape and finish. Your purchase empowers weavers, backed by verified quality, secure payments, simple returns, and fast pan-India shipping, timeless luxury, responsibly made.",
//   },
//   {
//     image: "/img/banscroll2.webp",
//     // image: "/images/scroll2.jpg",
//     alt: "Two women in colourful sarees",
//     title: "For Superior Drape and Finish",
//     text: "At Gehen, we believe every thread tells a story. We’re on a mission to bring hand curated elegance to the modern wardrobe. Rooted in tradition and driven by creativity, our experiences have reached homes across India. And guess what? We’re just getting started. And hey — the best part of our story might just include you.",
//     cta: { label: "Slide into soft rebellion", path: "/products" },
//   },
// ];

// const BanScrollParatha = () => {
//   const [active, setActive] = useState(0);
//   const wrapperRef = useRef(null);
//   const panelRef = useRef(null);

//   /* Scroll progress se active slide nikalna */
//   useEffect(() => {
//     let ticking = false;

//     const update = () => {
//       ticking = false;
//       const wrapper = wrapperRef.current;
//       const panel = panelRef.current;
//       if (!wrapper || !panel) return;

//       const wrapperTop = wrapper.getBoundingClientRect().top;
//       const stickyTop = parseFloat(getComputedStyle(panel).top) || 0;
//       const total = wrapper.offsetHeight - panel.offsetHeight;
//       if (total <= 0) return;

//       const scrolled = stickyTop - wrapperTop;
//       const progress = Math.min(1, Math.max(0, scrolled / total));
//       const index = Math.min(SLIDES.length - 1, Math.floor(progress * SLIDES.length));

//       setActive((prev) => (prev === index ? prev : index));
//     };

//     const onScroll = () => {
//       if (!ticking) {
//         ticking = true;
//         requestAnimationFrame(update);
//       }
//     };

//     update();
//     window.addEventListener("scroll", onScroll, { passive: true });
//     window.addEventListener("resize", onScroll);
//     return () => {
//       window.removeEventListener("scroll", onScroll);
//       window.removeEventListener("resize", onScroll);
//     };
//   }, []);

//   return (
//     <section
//       className="banscrollparatha-wrapper"
//       ref={wrapperRef}
//       style={{ "--banscrollparatha-steps": SLIDES.length - 1 }}
//     >
//       <div className="banscrollparatha-panel" ref={panelRef}>
//         {/* Left: images */}
//         <div className="banscrollparatha-media">
//           <div className="banscrollparatha-frame">
//             {SLIDES.map((slide, index) => (
//               <img
//                 key={index}
//                 src={slide.image}
//                 alt={slide.alt || ""}
//                 className={`banscrollparatha-img ${
//                   index === active ? "banscrollparatha-active" : ""
//                 }`}
//                 loading={index === 0 ? "eager" : "lazy"}
//                 draggable={false}
//               />
//             ))}
//           </div>
//         </div>

//         {/* Right: content */}
//         <div className="banscrollparatha-content">
//           {SLIDES.map((slide, index) => (
//             <div
//               key={index}
//               className={`banscrollparatha-slide ${
//                 index === active ? "banscrollparatha-active" : ""
//               }`}
//               aria-hidden={index !== active}
//             >
//               {slide.eyebrow && (
//                 <p className="banscrollparatha-eyebrow">{slide.eyebrow}</p>
//               )}

//               <h2 className="banscrollparatha-title">{slide.title}</h2>
//               <p className="banscrollparatha-text">{slide.text}</p>

//               {slide.cta && (
//                 <Link
//                   to={slide.cta.path}
//                   className="banscrollparatha-cta"
//                   tabIndex={index === active ? 0 : -1}
//                 >
//                   {slide.cta.label}
//                 </Link>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BanScrollParatha;









// 04-11-2026 dyanamic code
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./BanScrollParatha.css";

const API_URL =
  "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_z_why_choose_us";

/* Last slide par jo button dikhta tha (API mein nahi hai, isliye static) */
const CTA = { label: "Slide into soft rebellion", path: "/products" };

/* API item -> slide shape */
const mapSlide = (item) => ({
  id: item.id,
  image: item.image_url,
  alt: item.heading || "",
  eyebrow: item.sub_heading,
  title: item.heading,
  text: item.description,
});

const BanScrollParatha = () => {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [active, setActive] = useState(0);
  const wrapperRef = useRef(null);
  const panelRef = useRef(null);

  /* ---------------- API fetch ---------------- */
  useEffect(() => {
    const controller = new AbortController();

    const fetchSlides = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await fetch(API_URL, { signal: controller.signal });
        if (!res.ok) throw new Error("Network response was not ok");
        const json = await res.json();

        const ok =
          json?.success === "1" ||
          json?.success === 1 ||
          json?.status === "true" ||
          json?.status === true;

        if (!ok || !json.data) {
          throw new Error(json?.message || "Failed to load content");
        }

        // data single object ho ya array, dono handle
        const list = Array.isArray(json.data) ? json.data : [json.data];

        // A -> B: admin se jo pehla add hua wo pehle slide par
        const sorted = [...list].sort((a, b) => Number(a.id) - Number(b.id));
        setSlides(sorted.map(mapSlide));
      } catch (err) {
        if (err.name !== "AbortError") {
          setError("Something went wrong while loading content.");
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    fetchSlides();
    return () => controller.abort();
  }, []);

  /* Scroll progress se active slide nikalna */
  useEffect(() => {
    if (slides.length === 0) return;

    let ticking = false;

    const update = () => {
      ticking = false;
      const wrapper = wrapperRef.current;
      const panel = panelRef.current;
      if (!wrapper || !panel) return;

      const wrapperTop = wrapper.getBoundingClientRect().top;
      const stickyTop = parseFloat(getComputedStyle(panel).top) || 0;
      const total = wrapper.offsetHeight - panel.offsetHeight;
      if (total <= 0) return;

      const scrolled = stickyTop - wrapperTop;
      const progress = Math.min(1, Math.max(0, scrolled / total));
      const index = Math.min(slides.length - 1, Math.floor(progress * slides.length));

      setActive((prev) => (prev === index ? prev : index));
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [slides]);

  if (loading || error || slides.length === 0) return null;

  return (
    <section
      className="banscrollparatha-wrapper"
      ref={wrapperRef}
      style={{ "--banscrollparatha-steps": slides.length - 1 }}
    >
      <div className="banscrollparatha-panel" ref={panelRef}>
        {/* Left: images */}
        <div className="banscrollparatha-media">
          <div className="banscrollparatha-frame">
            {slides.map((slide, index) => (
              <img
                key={slide.id}
                src={slide.image}
                alt={slide.alt}
                className={`banscrollparatha-img ${
                  index === active ? "banscrollparatha-active" : ""
                }`}
                loading={index === 0 ? "eager" : "lazy"}
                draggable={false}
              />
            ))}
          </div>
        </div>

        {/* Right: content */}
        <div className="banscrollparatha-content">
          {slides.map((slide, index) => {
            const isLast = index === slides.length - 1;
            return (
              <div
                key={slide.id}
                className={`banscrollparatha-slide ${
                  index === active ? "banscrollparatha-active" : ""
                }`}
                aria-hidden={index !== active}
              >
                {slide.eyebrow && (
                  <p className="banscrollparatha-eyebrow">{slide.eyebrow}</p>
                )}

                <h2 className="banscrollparatha-title">{slide.title}</h2>
                <p className="banscrollparatha-text">{slide.text}</p>

                {/* CTA sirf last slide par (static jaisa) */}
                {/* {isLast && slides.length > 1 && (
                  <Link
                    to={CTA.path}
                    className="banscrollparatha-cta"
                    tabIndex={index === active ? 0 : -1}
                  >
                    {CTA.label}
                  </Link>
                )} */}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BanScrollParatha;